export type CrudTab = {
  label: string;
  value: string | null;
  count?: number;
};

type Props = {
  tabs: CrudTab[];
  activeValue: string | null;
  onChange: (value: string | null) => void;
};

function CrudTabs({ tabs, activeValue, onChange }: Props) {
  return (
    <div className="flex gap-0 border-b border-slate-200 mb-4">
      {tabs.map((tab) => {
        const isActive = tab.value === activeValue;
        return (
          <button
            key={tab.value ?? "__all__"}
            type="button"
            onClick={() => onChange(tab.value)}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
              isActive
                ? "border-primary text-primary"
                : "border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
            }`}
          >
            {tab.label}
            {tab.count !== undefined && (
              <span
                className={`inline-flex items-center justify-center rounded-full px-1.5 py-0.5 text-xs font-semibold min-w-[20px] ${
                  isActive
                    ? "bg-primary text-white"
                    : "bg-slate-100 text-slate-500"
                }`}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default CrudTabs;
